<template>
<div class="container">
  <div class="row">
    <div class="col">
      <h1>Details</h1>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <h2>What Do my Customers See?</h2>
    </div>
  </div>
  <div class="row">
    <div class="col-md-3 text-right my-auto">
      <p class="no-margin-bottom">Company Name</p>
    </div>
    <div class="col-md-9 my-auto">
      <input v-model="companyName" class="form-control form-control-md">
    </div>
  </div>
  <div class="row">
    <div class="col-md-3 text-right my-auto">
      <p class="no-margin-bottom">Address</p>
    </div>
    <div class="col-md-9 my-auto">
      <input v-model="address" class="form-control form-control-md">
    </div>
  </div>
  <div class="row">
    <div class="col-md-3 text-right my-auto">
      <p class="no-margin-bottom">Latitude</p>
    </div>
    <div class="col-md-9 my-auto">
      <input v-model="latitude" class="form-control form-control-md">
    </div>
  </div>
  <div class="row">
    <div class="col-md-3 text-right my-auto">
      <p class="no-margin-bottom">Longitude</p>
    </div>
    <div class="col-md-9 my-auto">
      <input v-model="longitude" class="form-control form-control-md">
    </div>
  </div>
  <div class="row">
    <div class="col-md-3 text-right my-auto">
      <p class="no-margin-bottom">Search Categories</p>
    </div>
    <div class="col-md-9 my-auto">
      <input v-model="category" class="form-control form-control-md">
    </div>
  </div>
  <div class="row">
    <div class="col-md-3 text-right my-auto">
      <p class="no-margin-bottom">Company Overview</p>
    </div>
    <div class="col-md-9 my-auto">
      <input v-model="details" class="form-control form-control-md">
    </div>
  </div>
  <div class="row">
    <div class="col-md-3 text-right my-auto">
      <p class="no-margin-bottom">Preferred Customer Contact Methods</p>
    </div>
    <div class="col-md-3 my-auto">
      <input type="checkbox" id="Call" value="Call" v-model="preferredCommunication">
      <label for="Call">Call</label>
    </div>
    <div class="col-md-3 my-auto">
      <input type="checkbox" id="Text" value="Text" v-model="preferredCommunication">
      <label for="Text">Text</label>
    </div>
    <div class="col-md-3 my-auto">
      <input type="checkbox" id="Email" value="Email" v-model="preferredCommunication">
      <label for="Email">Email</label>
    </div>
  </div>
  <div class="row">
    <div class="col-md-3 text-right my-auto">
      <p class="no-margin-bottom">Customer Contact Phone Number</p>
    </div>
    <div class="col-md-9 my-auto">
      <input v-model="callNumber" class="form-control form-control-md">
    </div>
  </div>
  <div class="row">
    <div class="col-md-3 text-right my-auto">
      <p class="no-margin-bottom">Customer Contact Text Number</p>
    </div>
    <div class="col-md-9 my-auto">
      <input v-model="textNumber" class="form-control form-control-md">
    </div>
  </div>
  <div class="row">
    <div class="col-md-3 text-right my-auto">
      <p class="no-margin-bottom">Customer Contact Email</p>
    </div>
    <div class="col-md-9 my-auto">
      <input v-model="email" class="form-control form-control-md">
    </div>
  </div>
  <div class="row no-bottom-margin">
    <div class="col-md-3 text-right my-auto">
      <p class="no-margin-bottom">Company Logo</p>
    </div>
    <div class="col-md-9 my-auto">
      <label class="custom-file-label" for="customFile">Upload file</label>
      <input class="custom-file-input" id="customFile" type="file" accept="image/png, image/jpeg" v-on:change="previewImage">
    </div>
  </div>
  <div class="row">
    <div class="col-md-3 text-right my-auto">
    </div>
    <div class="col-md-9 my-auto">
      <div class="preview-container">
        <img class="preview-image" v-bind:src="getLogo" v-on:click="updateLogo(null)" height="100px">
        <circle-enclosed-x-button v-if="getLogo" v-on:x-button-clicked="updateLogo(null)" class="preview-button"></circle-enclosed-x-button>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-3 text-right my-auto">
      <p class="no-margin-bottom">Coupon Text</p>
    </div>
    <div class="col-md-9 my-auto">
      <input v-model="couponText" class="form-control form-control-md">
    </div>
  </div>
  <div class="row">
    <div class="col-md-3 text-right my-auto">
      <p class="no-margin-bottom">Referral Text</p>
    </div>
    <div class="col-md-9 my-auto">
      <input v-model="referralText" class="form-control form-control-md">
    </div>
  </div>
  <div class="row">
    <div class="col-lg-4 offset-lg-4">
      <button v-on:click="updateServiceProvider()" class="btn btn-primary">Save</button>
    </div>
  </div>
</div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { Chrome } from 'vue-color'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import CircleEnclosedXButton from '../../general/buttons/CircleEnclosedXButton.vue'

export default {
  components: {
    'color-picker': Chrome,
    CircleEnclosedXButton,
    Loading
  },
  data () {
    return {
      loading: false
    }
  },
  methods: {
    ...mapActions('user', [
      'getCurrentUserData'
    ]),
    ...mapActions('serviceProvider', [
      'getCurrentServiceProviderData',
      'putServiceProviderData'
    ]),
    ...mapMutations('serviceProvider', [
      'updateAddress',
      'updateCallNumber',
      'updateCategory',
      'updateDetails',
      'updateEmail',
      'updateLogo',
      'updateCompanyName',
      'updatePreferredCommunication',
      'updateCouponText',
      'updateReferralText',
      'updateLatitude',
      'updateLongitude',
      'updateTextNumber'
    ]),
    previewImage: function (event) {
      var input = event.target
      var that = this
      if (input.files && input.files[0]) {
        var reader = new FileReader()
        reader.onload = function (e) {
          if (!that.profilePicture || (that.profilePicture && !that.profilePicture.includes(e.target.result))) {
            var img = new Image()
            img.onload = function () {
              if (this.width > 150 && this.height > 150) {
                that.updateLogo(e.target.result)
              } else {
                that.imageTooSmall = true
              }
            }
          }
          img.src = e.target.result
        }
        reader.readAsDataURL(input.files[0])
      }

      var fileInput = document.getElementById('customFile')
      fileInput.value = null
    },
    async updateServiceProvider () {
      this.loading = true
      try {
        await this.putServiceProviderData({ companyId: this.getCompanyId })
        await this.getCurrentServiceProviderData(this.getCompanyId)
        // this.getCurrentUserData()
      } catch (error) {
        console.log(error)
      }
      this.loading = false
    }
  },
  computed: {
    ...mapGetters([
      'getCognitoId',
      'getIdProvider'
    ]),
    ...mapGetters('serviceProvider', [
      'getAddress',
      'getCallNumber',
      'getCategory',
      'getDetails',
      'getEmail',
      'getCompanyId',
      'getLogo',
      'getCompanyName',
      'getPreferredCommunication',
      'getCouponText',
      'getReferralText',
      'getLatitude',
      'getLongitude',
      'getTextNumber'
    ]),
    address: {
      get () {
        return this.getAddress
      },
      set (value) {
        this.updateAddress(value)
      }
    },
    callNumber: {
      get () {
        return this.getCallNumber
      },
      set (value) {
        this.updateCallNumber(value)
      }
    },
    category: {
      get () {
        return this.getCategory
      },
      set (value) {
        this.updateCategory(value)
      }
    },
    details: {
      get () {
        return this.getDetails
      },
      set (value) {
        this.updateDetails(value)
      }
    },
    email: {
      get () {
        return this.getEmail
      },
      set (value) {
        this.updateEmail(value)
      }
    },
    companyId: {
      get () {
        return this.getCompanyId
      },
      set (value) {
        this.updateCompanyId(value)
      }
    },
    companyName: {
      get () {
        return this.getCompanyName
      },
      set (value) {
        this.updateCompanyName(value)
      }
    },
    preferredCommunication: {
      get () {
        return this.getPreferredCommunication
      },
      set (value) {
        this.updatePreferredCommunication(value)
      }
    },
    latitude: {
      get () {
        return this.getLatitude
      },
      set (value) {
        this.updateLatitude(value)
      }
    },
    longitude: {
      get () {
        return this.getLongitude
      },
      set (value) {
        this.updateLongitude(value)
      }
    },
    couponText: {
      get () {
        return this.getCouponText
      },
      set (value) {
        this.updateCouponText(value)
      }
    },
    referralText: {
      get () {
        return this.getReferralText
      },
      set (value) {
        this.updateReferralText(value)
      }
    },
    textNumber: {
      get () {
        return this.getTextNumber
      },
      set (value) {
        this.updateTextNumber(value)
      }
    },
    profilePicture: {
      get () {
        return this.getLogo
      },
      set (value) {
        this.updateLogo(value)
      }
    }
  }
}
</script>

<style scoped>
.phone-number >>> input {
  color: #495057;
}

.border-red {
  border-color: red;
}

.border-red:focus-within {
  border-color: #dc3545;
  box-shadow: 0 0 0 .2rem rgba(220,53,69,.25);
}

.container {
  margin-bottom: 3rem;
  border-radius: 25px;
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.no-margin-bottom {
  margin-bottom: 0px;
}

.row {
  margin-bottom: 1rem;
}

.red-text {
  color: red;
}

@media (max-width: 768px) {
  .text-right {
    text-align: left !important;
    padding-left: 1rem;
  }
}

.needs-margin-right {
  margin-left: .75rem;
}

.preview-button {
  cursor: pointer;
  left: 16px;
  position: absolute;
  top: 6px;
}

.preview-container {
  display: block;
  height: auto;
}

.preview-image {
  cursor: pointer;
  display: block;
  //margin: 0 auto !important;
  max-height: 300px;
}

.custom-file-input {
  line-height: 1.25;
}

.custom-file-label {
  margin-left: 15px;
  margin-right: 15px;
  line-height: 1.25;
}

.custom-file-label::after {
  line-height: 1.25;
}

.fix-custom-label {
  padding: 0;
  margin: 0 15px;
}

.color-picker {
  position: absolute;
  top: 39px;
  right: 15px;
  z-index: 3;
}

.current-color {
  display: inline-block;
  width: 16px;
  height: 16px;
}

.pointer-cursor {
  cursor: pointer;
}

.no-bottom-margin {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/profile/serviceProviderProfile/ServiceProviderDetails.vue